import {StoragePromoCodeRepository} from '@domain/model/PromoCode/StoragePromoCodeRepository';
import {PromoCode, PromoType} from '@domain/model/PromoCode/PromoCode';

const GetBoxRequestPromoCode = (repository: StoragePromoCodeRepository) => (): PromoCode | null => {
  const value = repository.getPromoBoxRequest();
  return value ? {value, type: PromoType.MANUAL} : null;
};

export {GetBoxRequestPromoCode};
